module.exports = __webpack_public_path__ + "6955705d277645c8826502bf04d11327.pdf";